import { Controller } from "@hotwired/stimulus";

// Formats decimal price input with currency display
export default class extends Controller {
  static targets = ["input", "display"];
  static values = { currency: { type: String, default: "USD" } };

  connect() {
    this._updateDisplay();
  }

  update() {
    this._updateDisplay();
  }

  // Private

  _updateDisplay() {
    if (!this.hasDisplayTarget || !this.hasInputTarget) return;

    const price = parseFloat(this.inputTarget.value);
    if (isNaN(price) || price <= 0) {
      this.displayTarget.textContent = "";
    } else {
      this.displayTarget.textContent = `= ${price.toFixed(2)} ${this.currencyValue}`;
    }
  }
}
